var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWavingKiwi = function SvgWavingKiwi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-11956 14062.376 97.965 81.624",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bcf1ff;\n      }\n\n      .cls-2, .cls-7 {\n        fill: #b2926e;\n      }\n\n      .cls-3 {\n        fill: #fec95f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #585858;\n      }\n\n      .cls-6 {\n        fill: #a78866;\n      }\n\n      .cls-7 {\n        opacity: 0.302;\n      }\n\n      .cls-8 {\n        fill: #e5b452;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16647",
    "data-name": "Group 16647",
    transform: "translate(-11956 14062.376)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_855",
    "data-name": "Ellipse 855",
    className: "cls-1",
    cx: 40.812,
    cy: 40.812,
    rx: 40.812,
    ry: 40.812,
    transform: "translate(16.34 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_25",
    "data-name": "Intersection 25",
    className: "cls-2",
    d: "M0,48.444c.823-5.4,3.552-11.048,12.009-15.3,16.761-8.418,2.831-18.6,2.831-18.6H1.436C7.4,10.908,9-5.041,24.564,1.6,36.729,6.791,48.456,28.445,46.494,43.577A41.089,41.089,0,0,1,19.732,53.53,40.727,40.727,0,0,1,0,48.444Z",
    transform: "translate(37.332 28.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-3",
    d: "M36.537,3.108c-4.153.44-11.417,4.787-22.569,14.138S-.7,33.427.112,34.758s7.9-5.247,22.528-12.166,22.8-6.734,29.394-10.628,7.1-10.248,4.2-11.71S51.315,4.132,47.149,3.4A38.1,38.1,0,0,0,36.537,3.108Z",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 14.208, 13.043)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14166",
    "data-name": "Group 14166",
    transform: "translate(33.976 12.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse",
    className: "cls-4",
    d: "M6.754,0c3.754.019,6.817,3.856,6.841,8.57s-3,8.519-6.754,8.5S.024,13.214,0,8.5,3-.019,6.754,0Z",
    transform: "translate(2.75 2.756) rotate(9.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    className: "cls-2",
    d: "M8.324,2a6.727,6.727,0,0,0-4-2C1.6.007.028,3.572,0,3.844S2.25,1.415,4.213,1.088,8.3,2.276,8.324,2Z",
    transform: "translate(0.385 1.588) rotate(-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    className: "cls-2",
    d: "M9.2,1.359c1.322,1.905.477,5.125-1.891,7.188S1.947,10.732.625,8.818.147,3.694,2.516,1.631,7.877-.554,9.2,1.359Z",
    transform: "translate(0.697 10.763) rotate(-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    className: "cls-5",
    d: "M5.749.847c.825,1.192.293,3.2-1.183,4.489S1.213,6.7.389,5.505.1,2.3,1.572,1.016,4.925-.345,5.749.847Z",
    transform: "translate(3.184 11.16) rotate(-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    className: "cls-4",
    d: "M1.65,1.716c.239-.789.086-1.579-.338-1.7S.351.461.113,1.282.027,2.861.45,2.981,1.411,2.536,1.65,1.716Z",
    transform: "matrix(-0.875, -0.485, 0.485, -0.875, 6.707, 10.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse-2",
    "data-name": "ellipse",
    className: "cls-4",
    d: "M7.751,0c4.315.028,7.841,4.438,7.875,9.849S12.19,19.626,7.875,19.6.035,15.16,0,9.748,3.436-.028,7.751,0Z",
    transform: "matrix(0.965, 0.263, -0.263, 0.965, 15.07, 2.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    className: "cls-2",
    d: "M10.229,1.521c1.473,2.13.536,5.726-2.1,8.029S2.17,11.986.7,9.847s-.536-5.726,2.1-8.029S8.756-.618,10.229,1.521Z",
    transform: "translate(12.668 11.468) rotate(-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    className: "cls-5",
    d: "M6.393.948c.918,1.333.329,3.58-1.312,5.015S1.352,7.489.433,6.147.1,2.568,1.745,1.132,5.475-.385,6.393.948Z",
    transform: "translate(15.377 12.204) rotate(-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    className: "cls-4",
    d: "M1.842,1.911c.266-.877.094-1.758-.379-1.892S.39.513.125,1.425.031,3.183.5,3.318,1.576,2.823,1.842,1.911Z",
    transform: "translate(19.49 12.01) rotate(-147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    "data-name": "path",
    className: "cls-2",
    d: "M4.03,8.355c.226-.172,1.694-3.816.377-6.09A4.663,4.663,0,0,0,.015.055C-.211.227,2.24.71,3.5,2.954S3.8,8.527,4.03,8.355Z",
    transform: "translate(24.53 2.849) rotate(-11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9293",
    "data-name": "Path 9293",
    className: "cls-6",
    d: "M2.015,8.687a11.985,11.985,0,0,0-1.9,8.2L11.6,3.921,10.187,0S4.726,4.435,2.015,8.687Z",
    transform: "translate(63.285 41.853) rotate(-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9291",
    "data-name": "Path 9291",
    className: "cls-2",
    d: "M.51,24.194s-2.094-3.911,2.2-9.923A87.042,87.042,0,0,1,9.643,5.89c.65-.7,1.635-1.706,2.605-2.634C14.51,1.094,16.772-.5,17.686.142c2.026,1.415.83,15.221-2.647,25.926",
    transform: "translate(67.014 34.999) rotate(-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9290",
    "data-name": "Path 9290",
    className: "cls-7",
    d: "M.51,24.194s-2.094-3.911,2.2-9.923a87.051,87.051,0,0,1,6.932-8.38c.65-.7,1.635-1.706,2.606-2.634C14.511,1.094,16.772-.5,17.686.142c1.639,1.145,1.495,9.839-.478,18.863-.445,2.036-1.008,4.162-1.672,6.207",
    transform: "translate(75.402 34.945) rotate(24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9292",
    "data-name": "Path 9292",
    className: "cls-7",
    d: "M.5,23.7s-2.053-3.835,2.157-9.729a85.336,85.336,0,0,1,6.8-8.216c.637-.685,1.267-1.217,2.218-2.126C13.89,1.5,16.443-.509,17.339.115,19.325,1.5,18.642,14.2,15.233,24.7",
    transform: "translate(60.96 38.021) rotate(-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9294",
    "data-name": "Path 9294",
    className: "cls-8",
    d: "M.008,1.746c-.168-.634,2.3.429,4.339.01S8.4-.557,8.987.161,7.738,3.736,5.018,4.294A4.948,4.948,0,0,1,.008,1.746Z",
    transform: "translate(51.598 38.273) rotate(7)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWavingKiwi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wavingKiwi.e0b25da6.svg";
export { ForwardRef as ReactComponent };